export default "__VITE_ASSET__D9A2MmI8__"